const clearFilterButton = {
  Typography: 'Limpar'
};

export default clearFilterButton;
